let path = ''
if (process.env.NODE_ENV === 'development') {
  // path = '/lh'
  path = '/f1_core'
} else {
  path = 'https://xy.91fd.com/api'
}

export default {
  path
}
